import ToastMessagesList from './ToastMessagesList';
import { connect } from 'react-redux';

import { toastMessagesRightTop } from '../ToastMessagesSelectors';

function mapStateToProps (state) {
  return {
    messagesRightTop: toastMessagesRightTop(state),
  };
}

export default connect(mapStateToProps)(ToastMessagesList);
